module.exports = __webpack_public_path__ + "media/trail/icons-buttons-save-map-fd0c6de9.svg";